<template>
  <div class="DqKanBan">
    <h1 style="text-align:center; margin: 0vh 0vh 2vh 0; line-height: 12vh;">
      物流部总看板
    </h1>
    <div>
      <div style="width:9%;height:80vh;float:left" class="body">
        <div style="height:20vh;border-top:1px solid #fff;border-left:1px solid #fff">
          <div style="font-size:1.5em;line-height:10vh;height:10vh">
            当天
          </div>
          <div style="font-size:1.5em;line-height:10vh;height:10vh">
            出料率
          </div>
        </div>
        <div style="height:20vh;border-left:1px solid #fff">
          <div style="font-size:1.5em;line-height:10vh;height:10vh">
            月度
          </div>
          <div style="font-size:1.5em;line-height:10vh;height:10vh">
            出料率
          </div>
        </div>
        <div style="height:20vh;border-left:1px solid #fff;border-bottom:none">
          <div style="font-size:1.5em;line-height:10vh;height:10vh;border-top:1px solid #fff">当天</div>
          <div style="font-size:1.5em;line-height:10vh;height:10vh;">包装率</div>
        </div>
        <div style="height:20vh;border-left:1px solid #fff;border-bottom:none">
          <div style="font-size:1.5em;line-height:10vh;height:10vh;">月度</div>
          <div style="font-size:1.5em;line-height:10vh;height:10vh;border-bottom:1px solid #fff">包装率</div>
        </div>
      </div>
      <div v-for="(item,index) in kzgKanBanVO" :key="index" :class=" index <= 2 ? 'chartBox':'chartBox1'">
        <chart-page :total-kanban-vo="item" :chart-class="'chart'+(index+1)" :chart-class2="'chart'+(index+6)"/>
      </div>
    </div> 
  </div>
</template>

<script>
  import "echarts-liquidfill";
  import ChartPage from "./chartPart";
  export default {
    components:{ChartPage},
    data() {
      return {
        kzgKanBanVO:[],
        lastDayPlan: 0,
        lastDayDone: 0,
        todayPlan: 0,
        todayDone: 0,
      };
    },
    mounted() {
      this.getKGList();
      var that = this;//防止this指向问题
      var timer = setInterval(function() {
        // 判断页面所有资源已加载完毕
        if (document.readyState === "complete") {
          that.myChart1 = that.$echarts.init(document.querySelector(".chart1"));
          that.myChart2 = that.$echarts.init(document.querySelector(".chart2"));
          that.myChart3 = that.$echarts.init(document.querySelector(".chart3"));
          that.myChart4 = that.$echarts.init(document.querySelector(".chart4"));
          that.myChart5 = that.$echarts.init(document.querySelector(".chart5"));
          that.myChart6 = that.$echarts.init(document.querySelector(".chart6"));
          that.myChart7 = that.$echarts.init(document.querySelector(".chart7"));
          that.myChart8 = that.$echarts.init(document.querySelector(".chart8"));
          that.myChart9 = that.$echarts.init(document.querySelector(".chart9"));
          that.myChart10 = that.$echarts.init(document.querySelector(".chart10"));
          that.$nextTick(() => {
            for(var i = 0;i < 5;i++) {
              that.setOptions(i);
              that.setOptions2(i);
            }
          });
          window.clearInterval(timer);
        }
      }, 800);
      setInterval(() => {
        this.getKGList();
        that.$nextTick(() => {
          for(var i = 0;i < 5;i++) {
            that.setOptions(i);
            that.setOptions2(i);
          }
        });
      }, 1000 * 60 * 20);
    },
    methods: {
      getKGList() {
        this.$http.get("basic","kanban/getWareHouseTotalKanBanVO").then(res => {
          this.kzgKanBanVO = res;
          console.log(this.kzgKanBanVO);
        });
      },
      setOptions(index) {
        var chart = "";
        switch(index) {
          case 0:
            chart = this.myChart1;
            break;
          case 1:
            chart = this.myChart2;
            break;
          case 2:
            chart = this.myChart3;
            break;
          case 3:
            chart = this.myChart4;
            break;
          case 4:
            chart = this.myChart5;
            break;
          default:
            break;
        }
        chart.setOption({
          backgroundColor: "#2D4054",
          title: [
            {
              text: "\n" + this.kzgKanBanVO[index].wareHouseType +"\n",
              left: "left",
              top:"-15",
              textStyle: {
                fontWeight: "normal",
                fontSize: this.fontSize(0.5),
                color: "#3fecff",
              },
            },
          ],
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.kzgKanBanVO[index].currentDayNum/this.kzgKanBanVO[index].currentDayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.03),
              borderColor: "#ccc",
              color: "#2d4059",
            },
            label: {
              normal: {
                formatter: this.chartValueFormatter(this.kzgKanBanVO[index].currentDayNum, this.kzgKanBanVO[index].currentDayPlanNum) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.4),
                  color: "#fdd100",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.03),
                borderColor: "#666",
              },
            },
          }],
        });
      },
      setOptions2(index) {
        var chart = "";
        switch(index) {
          case 0:
            chart = this.myChart6;
            break;
          case 1:
            chart = this.myChart7;
            break;
          case 2:
            chart = this.myChart8;
            break;
          case 3:
            chart = this.myChart9;
            break;
          case 4:
            chart = this.myChart10;
            break;
          default:
            break;
        }
        chart.setOption({
          backgroundColor: "#2D4054",
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.kzgKanBanVO[index].currentMonthNum/this.kzgKanBanVO[index].currentMonthPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.03),
              borderColor: "#ccc",
              color: "#2d4059",
            },
            label: {
              normal: {
                formatter: this.chartValueFormatter(this.kzgKanBanVO[index].currentMonthNum, this.kzgKanBanVO[index].currentMonthPlanNum) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.4),
                  color: "#fdd100",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.03),
                borderColor: "#666",
              },
            },
          }],
        });
      },
      chartValueFormatter(value1, value2) {
        if (value1 == 0 || value2 == 0) {
          return 0;
        }
        return Math.floor(value1 * 100/value2);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .DqKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar, ::-webkit-scrollbar-track {
      background-color: transparent!important;
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .clear{
      clear:both
    }
    .words {
      font-size: 1.5em;
      text-align: left;
      position: absolute;
      left: 1vw;
      top: 8vh;
      z-index: 999;
    }
    .box {
      width: 100%;
      height: 20vh;
      border-bottom:1px solid #fff;
    }
    .words2 {
      font-size: 1.5em;
      text-align: left;
      position: absolute;
      left: 1vw;
      top: 27vh;
      z-index: 999;
    }
    .chartBox1 .words2 {
      position: absolute;
      left: 5vw;
    }
    .chartBox1 .words {
      position: absolute;
      left: 5vw;
    }

    .chartBox {
      width: 30%;
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      float: left;
      position: relative;
      height: 40vh;
      background-color: #2D4054;
      overflow: hidden;
    }
    // .chartBox :last-child {
    //   border-right: 1px solid #ccc;
    // }
    .chartBox .chart {
      width: 100%; 
      height: 19vh;
      margin-left:10vw;
    }
    .body div:last-child {
      border-bottom: 1px solid #fff;
    }
    .chartBox1 {
      width: 45%;
      border: 1px solid #ccc;
      float: left;
      position: relative;
      height: 40vh;
      background-color: #2D4054;
      overflow: hidden;
    }
    .chartBox1 .chart {
      width: 100%; 
      height: 20vh;
      margin-left:12vw;
    }
    .timeText{
      font-family: Arial-BoldMT;
      font-size: 4vh;
      line-height: 7vh;
      color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      //margin-bottom: 1vh;
      div{
        width: 50%;
        text-align: right;
      }
      .timeText-num{
        position: relative;
        display: flex;
        flex-direction: row;
        .timeText-num-img{
          width: 5vw;
          height: 9vh;
          line-height: 9vh;
          text-align: left;
          display: block;
          font-size: 7vh;
          color: #81C3FF;
          letter-spacing: 0.267vh;
          margin-left: 3%;
          background: url("../../../public/img/numbg.png") no-repeat;
          background-size: 100% 100%;
          text-align: center;
        }
      }

    }
  }
</style>